export const projects = [
  {
    title: "CineHub - Movie Discovery App",
    subtitle: "Explore, search, and discover your next favorite movie",
    description:
      "CineHub is a movie discovery web application that lets users search for movies, view detailed information, watch trailers, and see ratings. Powered by React and TypeScript, it provides a clean, responsive UI with seamless navigation.",
    image: "./movieapp.gif",
    link: "https://findmoviestowatch.netlify.app/",
  },
  {
    title: "Admin Dashboard - React Application",
    subtitle: "A modern admin panel for data and user management",
    description:
      "Admin Dashboard is a React-based web application designed for managing data, users, and analytics efficiently. It features interactive charts, real-time updates, and a responsive UI for a seamless experience. Built with React, TypeScript, and modern UI frameworks for scalability and performance.",
    image: "./admindashboard.gif",
    link: "https://admindashboardmgt.netlify.app/",
  },
  {
    title: "DelishEats - Food Ordering App",
    subtitle: "Order your favorite meals with ease",
    description:
      "DelishEats is a modern food ordering web application that allows users to browse a variety of dishes, add items to their cart, and complete orders seamlessly. Built with React, TypeScript, and styled for a smooth user experience.",
    image: "./foodorder.gif",
    link: "#", // Update the link when it's ready
  },
  {
    title: "StockPulse - Real-Time & Historical Market Insights",
    subtitle: "Live stock tracking with 20+ years of historical data",
    description:
      "StockPulse is a powerful stock market analysis tool that provides real-time and historical stock data using the Alpha Vantage API. Get detailed OHLCV (Open, High, Low, Close, Volume) data, including pre-market and post-market hours. Perfect for traders and investors looking to analyze market trends with interactive charts and financial insights.",
    image: "./stock.gif",
    link: "#", // Update the link when it's ready
  },
  {
    title: "My Product Store",
    subtitle: "A Modern E-Commerce Platform",
    description:
      "My Product Store is a feature-rich e-commerce platform designed to provide a seamless shopping experience. Built with React, Node.js, and MongoDB, it allows users to browse products, add items to their cart, and securely complete purchases. With a sleek UI and robust backend, it ensures fast performance and scalability.",
    image: "./productstore.gif",
    link: "#", // Update the link when it's ready
  },
  {
    title: "InvestWise - Investment Calculator",
    subtitle: "Plan and forecast your investments with ease",
    description:
      "InvestWise is a user-friendly investment calculator that helps users project their returns based on initial investment, interest rates, and time duration. Built with React and TypeScript, it offers real-time calculations and a sleek, intuitive interface.",
    image: "./investCal.gif",
    link: "https://calculateintrestapp.netlify.app/",
  },
];

export const testimonials = [
  {
    quote:
      "Working with Sam was an absolute pleasure! He took our project to the next level, and his attention to detail was exceptional. I would highly recommend him to anyone looking for quality work delivered on time.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "CineVibe Studios",
  },
  {
    quote:
      "The professionalism and expertise demonstrated by Sam exceeded all of our expectations. He truly understands the intricacies of both design and functionality. We've seen a significant increase in productivity since implementing his solutions.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "StockWise Investment",
  },
  {
    quote:
      "The project was completed ahead of schedule with outstanding quality. Sam's ability to quickly understand our needs and deliver exactly what we envisioned made all the difference. Truly a game-changer for our business.",
    image: "https://randomuser.me/api/portraits/men/2.jpg",
    name: "Jesse Hicks",
    company: "QuantumTrase Solutions",
  },
  {
    quote:
      "From start to finish, Sam was incredibly collaborative and flexible. He was always available to address our concerns and provided clear communication throughout the project. I can't recommend him enough!",
    image: "https://randomuser.me/api/portraits/men/3.jpg",
    name: "Ruben Alvarez",
    company: "PrimeCart Stores",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Next.js",
  "Node",
  "GraphQL",
  "Material UI",
  "TailwindCSS",
  "Flowbite",
  "Java",
  "Spring Boot",
  "AWS",
  "Docker",
  "Kubernetes",
  "MongoDB",
  "Jira",
  "Git",
  "Bitbucket",
  "GitLab",
  "Kafka",
  "Sonar",
];



// WEBPACK FOOTER //
// ./src/data.js